import React from 'react';
import {Layout} from './Layout';
import {createRoot} from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Layout />);
